"use strict";
/**
 * Single source of truth for upload MIME allowlists, used by the client
 * (asset library validation) and the server (upload endpoints).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_UPLOAD_MIME_TYPES = exports.ALLOWED_DOCUMENT_MIME_TYPES = exports.ALLOWED_VIDEO_MIME_TYPES = exports.ALLOWED_IMAGE_MIME_TYPES = void 0;
exports.ALLOWED_IMAGE_MIME_TYPES = [
    'image/bmp',
    'image/gif',
    'image/ief',
    'image/jpeg',
    'image/svg+xml',
    'image/tiff',
    'image/avif',
    'image/apng',
    'image/png',
    'image/webp',
    'image/heic',
    'image/heif',
];
exports.ALLOWED_VIDEO_MIME_TYPES = [
    'video/mpeg',
    'video/mp4',
    'video/quicktime',
    'video/x-flv',
    'video/x-msvideo',
    'video/x-ms-wmv',
    'video/webm',
    'video/x-m4v',
    'video/ogg',
    'video/3gpp',
    'video/3gpp2',
    'video/x-matroska',
    'video/avi',
];
exports.ALLOWED_DOCUMENT_MIME_TYPES = [
    // pdf
    'application/pdf',
    // word
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.document.macroEnabled.12',
    // excel
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    // powerpoint
    'application/vnd.ms-powerpoint.template.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    // other
    'text/csv',
    'application/csv',
    'application/json',
    'text/plain',
    'text/html',
    'text/calendar',
    'application/vnd.apple.pages',
    'application/vnd.apple.numbers',
    'application/vnd.apple.keynote',
    'application/wordperfect',
    'application/vnd.ms-write',
];
exports.ALLOWED_UPLOAD_MIME_TYPES = [
    ...exports.ALLOWED_IMAGE_MIME_TYPES,
    ...exports.ALLOWED_VIDEO_MIME_TYPES,
    ...exports.ALLOWED_DOCUMENT_MIME_TYPES,
];
